import { useState } from 'react';
import { cn, Stack } from '@prenuvo/halo-foundation';

import { DocumentError } from './document-error.component';
import { DocumentLoading } from './document-loading.component';

interface PatientDocIframeProps {
  url: string;
}

export function PatientDocIframe({ url }: PatientDocIframeProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  const show = {
    error: isError,
    loading: isLoading && !isError,
  };

  return (
    <>
      {(show.loading || show.error) && (
        <Stack className="mx-auto max-h-[calc(100vh-128px)] w-full overflow-auto">
          {show.loading && <DocumentLoading className="w-full" />}
          {show.error && <DocumentError className="w-full" />}
        </Stack>
      )}

      <Stack
        className={cn('mx-auto max-h-[calc(100vh-128px)] w-full overflow-auto', {
          'opacity-0': isLoading || isError,
        })}
      >
        <iframe
          className="flex h-[calc(100vh-128px)] w-full bg-white"
          loading="lazy"
          onError={() => setIsError(true)}
          onLoad={() => setIsLoading(false)}
          sandbox="allow-scripts allow-same-origin"
          src={url}
          title="Patient Document"
        />
      </Stack>
    </>
  );
}
